import React from 'react'
import './notFound.css'
import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <main className='page-error'>
      <h1 className='page-error__title'>404</h1>
      <p className='page-error__text'>Страница не найдена</p>
      <Link to='/' className='page-error__button'>
        Назад
      </Link>
    </main>
  )
}

export default NotFound
